import { ListItem, ListItemButton, ListItemText, Stack } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

import { isInHaltingStage } from 'components/attacks/utils/attack-stages'
import AttackTypeIcon from 'components/common/AttackTypeIcon'
import GlyphIcon from 'components/common/GlyphIcon'
import { HaltButton } from 'components/navigation/Notifications/NotificationsList/HaltButton'
import { ActiveAttackStatusText } from 'components/navigation/Notifications/NotificationsList/ListItems/ActiveAttackStatusText'
import { NOTIFICATION_LEFT_PADDING } from 'components/navigation/Notifications/utils'
import useAuth from 'hooks/use-auth'
import theme from 'theme'
import { InfraAttack } from 'types/api/attacks/details/infra-attack'
import { getFormattedAttackType } from 'utils/metadata'

export const ActiveAttackListItem: React.FC<{
  attack: InfraAttack
  doFetch(): void
  onConfirmHalt(options: Record<string, any>): void
}> = ({ attack, doFetch, onConfirmHalt, ...rest }) => {
  const { currentTeamId } = useAuth()

  const attackId = attack.guid
  const stage = attack.stage
  const isHalting = isInHaltingStage(stage)

  const handleHaltRequest = ({ reason } = { reason: '' }) =>
    onConfirmHalt({
      type: 'ilfi',
      attack,
      currentTeamId,
      reason,
      runNumber: null
    })

  const link = `/attacks/${attack.guid}`
  const IconWrapper = GlyphIcon
  const commandType =
    attack?.args[0] ?? attack?.infra_command?.commandArgs?.cliArgs[0]

  return (
    <ListItem
      data-test-notification-item
      disablePadding
      component="div"
      secondaryAction={
        <HaltButton
          fetchAttack={doFetch}
          isHalting={isHalting}
          trackingOptions={{ AttackId: attackId }}
          onConfirmRequest={handleHaltRequest}
        />
      }
      {...rest}
    >
      <ListItemButton component={Link} to={link}>
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          sx={{ pl: NOTIFICATION_LEFT_PADDING, width: '100%' }}
        >
          <IconWrapper
            css={{ marginRight: theme.space[3] }}
            data-test-attack-icon-type="infra"
          >
            <AttackTypeIcon icon={commandType} />
          </IconWrapper>

          <ListItemText
            data-test-notification-text
            primary={getFormattedAttackType(commandType)}
            secondary={
              <ActiveAttackStatusText
                attackStage={stage}
                isHalting={isHalting}
              />
            }
          />
        </Stack>
      </ListItemButton>
    </ListItem>
  )
}
